<template>
  <div id="box-fotos" class="columns is-multiline is-vcentered is-mobile" v-if="cantidadFotosSeleccionadas > 0">
    <div
      class="column is-12-mobile is-4-tablet is-3-widescreen is-2-fullhd"
      v-for="(imagen, index) in pagination.imagenesPaginaActual"
      :key="index"
    >
      <div class="card">
        <div class="card-header">
          <div class="card-header-title">
            <b-tooltip :label="imagen.name" type="is-light">{{ truncate(imagen.name, 10)}}..</b-tooltip>
          </div>
          <div class="card-header-icon">
            <b-tooltip label="Eliminar" type="is-danger">
              <button
                class="button is-danger"
                @click="$emit('eliminar-foto', { id: imagen.id, nombre: imagen.  name })"
              >
                <b-icon icon="delete"></b-icon>
              </button>
            </b-tooltip>
          </div>
        </div>
        <div class="card-content">
          <figure class="is-centered">
            <img class="imagen" :id="`imagen-${imagen.id}`" :alt="imagen.name" />
          </figure>
        </div>
        <footer class="card-footer">
          <div class="card-footer-item">
            <span v-if="imagen.status === 5" class="tag is-success">Subido</span>
            <span v-if="imagen.status === 4" class="tag is-danger">Error</span>
            <span v-if="imagen.status === 2" class="tag is-info">Subiendo</span>
            <span v-if="imagen.status === 1" class="tag is-primary">Preparado</span>
          </div>
          <div
            class="card-footer-item is-size-7"
          >{{ formatFileSize(imagen.size) }} - {{ imagen.percent }}%</div>
        </footer>
      </div>
    </div>
    <div class="column is-12">
      <b-pagination
        :total="cantidadFotosSeleccionadas"
        :current.sync="pagination.paginaActual"
        :range-before="pagination.rangeBefore"
        :range-after="pagination.rangeAfter"
        :order="pagination.order"
        :simple="pagination.isSimple"
        :rounded="pagination.isRounded"
        :per-page="pagination.perPage"
        :icon-prev="pagination.prevIcon"
        :icon-next="pagination.nextIcon"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        @change="cambiarPagina"
      ></b-pagination>
    </div>
  </div>
</template>

<style scoped>
#box-fotos {
  padding: 0.5rem;
}

@media only screen and (max-width: 768px) {
  #box-fotos {
    max-height: 400px;
    overflow-y: auto;
  }
}
.card {
  transition: transform 0.2s;
}
.card:hover {
  transform: scale(1.03);
}
.card {
  box-shadow: 0 0.5em 1em -0.125em grey, 0 0px 0 1px grey;
}
.imagen {
  max-width: 100px;
  max-height: 100px;
}
.is-centered {
  text-align: center;
}
</style>

<script>
export default {
  name: 'BoxFotosCard',
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      pagination: {
        imagenesPaginaActual: [],
        paginaActual: 1,
        rangeBefore: 2,
        rangeAfter: 2,
        perPage: 12,
        order: 'is-centered',
        isSimple: false,
        isRounded: false,
        prevIcon: 'chevron-left',
        nextIcon: 'chevron-right'
      }
    }
  },
  watch: {
    // Cada vez que se modifique la cantidad de fotos, cambia a la pagina 1
    cantidadFotosSeleccionadas (a, b) {
      this.cambiarPagina(1)
    }
  },
  props: {
    uploader: {
      type: Object,
      required: true
    },
    cantidadFotosSeleccionadas: {
      type: Number,
      required: true
    },
    tablaFotos: {
      type: Object,
      required: true
    }
  },
  methods: {
    cambiarPagina (paginaNueva) {
      this.pagination.paginaActual = paginaNueva
      this.pagination.imagenesPaginaActual = []
      for (
        let iFiles = 0 + this.pagination.perPage * (paginaNueva - 1), iPage = 0;
        iFiles < this.uploader.files.length && iPage < this.pagination.perPage;
        iFiles++
      ) {
        this.pagination.imagenesPaginaActual[iPage] = this.uploader.files[
          iFiles
        ]
        this.generarPreview(this.uploader.files[iFiles])
        iPage++
      }
    },
    // Resize de una imagen enviada en base64, a un tamaño max de h o w y la devuelve en base 64 async
    resizeImage (base64Str, maxWidth, maxHeight) {
      return new Promise(resolve => {
        const img = new Image()
        img.src = base64Str
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
    // Genera el preview de la imagen correspondiente
    generarPreview (imagen) {
      const componenteVue = this
      // Crear un reader para leer la imagen
      const reader = new window.FileReader()
      reader.readAsDataURL(imagen.getNative())

      // Cuando termine de leer el archivo asincronicamente, llamara a la funcion resizeImage que achica a los parametros indicados
      reader.onload = async function () {
        // Arma el base64 coded de la imagen
        let base64 = reader.result
        base64 = base64.substring(base64.indexOf(',') + 1)
        var fuente = 'data:' + imagen.type + ';base64,' + base64 // Aca se almacena finalmente el src para la imagen en base64
        // Se la asigna al elemento correspondiente (ver que el id se setea asi en el render de vue)
        document.getElementById(
          `imagen-${imagen.id}`
        ).src = await componenteVue.resizeImage(fuente, 200, 200)
      }
    },
    // Formate un size en bytes usando la funcion de plupload
    formatFileSize (size) {
      return this.$plupload.formatSize(size)
    },
    // Se encarga de manejar los resize de la pantalla y actualiza variables de data
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  created () {
    // Agrega event listener para el resize
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
